<script>
    import {afterUpdate, onMount} from "svelte";

    export let color;
    export let comment;

    $: state = !['Декорал'].includes(color);

    let selected = '';

    const colors = [
        ["Дуб белый", "/img/plisse/dekoral/Дуб белый.jpg"],
        ["Дуб золотой", "/img/plisse/dekoral/Дуб золотой.jpg"],
        ["Дуб испанский", "/img/plisse/dekoral/Дуб испанский.jpg"],
        ["Дуб модерн", "/img/plisse/dekoral/Дуб модерн.jpg"],
        ["Дуб тёмный", "/img/plisse/dekoral/Дуб тёмный.jpg"],
        ["Каштан светлый", "/img/plisse/dekoral/Каштан светлый.jpg"],
        ["Каштан тёмный", "/img/plisse/dekoral/Каштан тёмный.jpg"],
        ["Каштан", "/img/plisse/dekoral/Каштан.jpg"],
        ["Макассар", "/img/plisse/dekoral/Макассар.jpg"],
        ["Махагон", "/img/plisse/dekoral/Махагон.jpg"],
        ["Нарезная древесина т", "/img/plisse/dekoral/Нарезная древесина т.jpg"],
        ["Нарезная древесина", "/img/plisse/dekoral/Нарезная древесина.jpg"],
        ["Орех", "/img/plisse/dekoral/Орех.jpg"],
        ["Черешня тёмная", "/img/plisse/dekoral/Черешня тёмная.jpg"],
        ["Черешня", "/img/plisse/dekoral/Черешня.jpg"],
        ["Ясень белый", "/img/plisse/dekoral/Ясень белый.jpg"],
    ];
    // Функция для получения пути к изображению по выбранному названию
    function getImagePath(colorName) {
        const foundColor = colors.find(([name]) => name === colorName);
        return foundColor ? foundColor[1] : "";
    }
    const handler = ({target}) => {
        selected = target.value;
        comment = comment.replace(/DekoRal:.*?;/, ``).trim();
        comment = `DekoRal: ${selected}; ${comment}`.trim() ;
    }

    afterUpdate(() => {
        if (state) {
            selected = '';
            comment = comment.replace(/DekoRal:.*?;/, ``);
        } else {
            let match = comment.match(/DekoRal:.*?;/);

            if (match) {
                selected = match[0].replace('DekoRal:', ``).replace(';', ``).trim();
            }
        }
    })
</script>

{#if !state}
    <div class="col-6">
        <div class="form-group boxed">
            <div class="input-wrapper">
                <label class="form-label">Цвет DEKORAL</label>
                <div class="input-group">
                    <select class="form-control form-select" on:change={handler} bind:value={selected}>
                        <option value="" selected disabled>Выберите DEKORAL...</option>
                        {#each colors as [value]}
                            <option value="{value}">{value}</option>
                        {/each}
                    </select>

                    {#if selected}
                        <div class="input-group-append">
                            <img class="input-group-text p-0" src={getImagePath(selected)} alt={selected} />
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    img {
        height: 42px!important;
    }
</style>
